import {NumberFormatValues} from 'react-number-format';
import {Control, Controller} from 'react-hook-form';
import InputNumber from './InputNumber';

interface Props {
    control: Control<any, any>;
    name: string;
    className?: string;
    isAllowed?: (values: NumberFormatValues) => any;
    thousandSeparator?: boolean;
    allowLeadingZeros?: boolean;
    allowNegative?: boolean;
    disabled?: boolean;
}

/**
 * Uncontrolled-component 방식(react-hook-form 사용) number input
 * @param control - react-hook-form control
 * @param name - value 필드명
 * @param className - 추가 className
 * @param isAllow - 허용 validation
 * @param thousandSeparator - 천단위 콤마
 * @param allowLeadingZeros - 첫글자 0 허용
 * @param allowNegative - 음수 허용
 * @param disabled - disabled
 */
export default function InputNumberUc({
                                          control,
                                          name,
                                          className = '',
                                          isAllowed,
                                          thousandSeparator = true,
                                          allowLeadingZeros = false,
                                          allowNegative = true,
                                          disabled = false,
                                      }: Props) {
    return (
        <Controller
            render={({field}) => {
                return (
                    <InputNumber
                        value={field.value}
                        onValueChange={(values) => {
                            field.onChange(values.floatValue);
                        }}
                        className={`form-control text-end ${className}`}
                        isAllowed={isAllowed}
                        thousandSeparator={thousandSeparator}
                        allowLeadingZeros={allowLeadingZeros}
                        allowNegative={allowNegative}
                        displayType={'input'}
                        disabled={disabled}
                    />
                );
            }}
            control={control}
            name={name}
        />
    );
}
